import Vue from 'vue'
import Vuex from 'vuex'

import word from './word.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    word
  }
});